import { pricePerUnit } from "~/utils/formatters"
import { Theme } from "~/components/Badge/Product.props"

type Promotion = {
  theme: Theme | string
  text?: string | undefined
}

export default async (filterCategories: string | boolean) => {
  const transformProductsBannerBrand = (
    items: any[],
    queryID: string | null = null
  ) => {
    return items.map((item: any) => {
      let promotionsProduct: Promotion[] =
        item?.commercialTags && item?.commercialTags.length > 0
          ? item?.commercialTags.map((badge: string) => ({
              theme: badge,
              text: ""
            }))
          : []
      const discount = discountPercentage(
        item.price.amount_float,
        item.price.compare_at_amount_float
      )
      if (discount > 0)
        promotionsProduct.push({
          theme: "SCONTO",
          text: `-${discount}%`
        })
      return {
        productImage: item.mainImage,
        productCode: item.productCode,
        title: item.productName,
        reviews: item.ratings.rating.toString(),
        rating: item.ratings.reviews.toString(),
        oldPrice: "" + item.price.compare_at_amount_float,
        currentPrice: "" + item.price.amount_float,
        pricePerUnit: pricePerUnit(item.price.amount_float, 1),
        isPromo: item.isDiscounted,
        discount: item.price.discountPercentage,
        inStock: item.inStock,
        path: `/p-${item.slug}`,
        queryID: queryID ?? "",
        unitType: "unità",
        promotions: promotionsProduct
      }
    })
  }
  const bannersList = ref()

  const { data: getProductsBoosted, error: errorProductsBoosted } =
    await useFetch("/api/plp/getBoostProducts", {
      method: "GET"
    })

  if (errorProductsBoosted.value) {
    console.warn("ERROR GET PRODUCT BOOSTED", errorProductsBoosted.value)
  }

  // FUNCTION FOR GET ALL PRODUCTS FROM SEARCH AND FILTERS WITH ALL AVAILABLE BRAND BANNERS
  const fetchAllProductBanners = async (products: any[]) => {
    const filterProductBanners = await getProductsBoosted.value
      ?.map((brandBanner: any) => {
        const copyProducts = [...products]
        const findProduct =
          copyProducts.filter(
            (product: any) => product.productCode === brandBanner.card
          ) ?? null

        return {
          ...brandBanner,
          card: findProduct.length === 1 ? findProduct[0] : null
        }
      })
      .filter((item: any) => item.card && item.title !== "--")

    return filterProductBanners
  }

  // Call API ALGOLIA FOR PROMO BANNERS
  const data = await $fetch("/api/algolia/getBoostedProducts", {
    method: "POST",
    body: {
      querySearch: "",
      filterCategories: filterCategories,
      productCodes: getProductsBoosted.value.map((product: any) => product.card)
    }
  })
  if (data.hits && data.hits.length > 0) {
    const products = transformProductsBannerBrand(data.hits, data.queryID)
    bannersList.value = await fetchAllProductBanners(products)
  }

  return {
    bannersList
  }
}
